import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { internalKeyFigureTypes } from '../../../../pages/reporting/keyFigures/config'

const FormulaTypeField: React.FC = () => {
  const { t } = useTranslation()
  const keyFigureTypes = internalKeyFigureTypes

  return (
    <Form.Item
      name="type"
      label={t('global:type')}
      initialValue="absolute"
      rules={[
        {
          required: true,
          message: t('global:required-field')
        }
      ]}
    >
      <Select showSearch optionFilterProp="children" style={{ width: 300 }}>
        {keyFigureTypes.map(keyFigureType => (
          <Select.Option key={keyFigureType} value={keyFigureType}>
            {t(`keyFigurePage:${keyFigureType}`)}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default FormulaTypeField
